// Site-wide translations (FR / EN / PT / DE)
// Note: customTrip 9-step (ct2) translations preserved at the bottom of each language block.

const COMMON = {
  fr: {
    nav: {
      home: 'Accueil',
      customTrip: 'Voyages Sur Mesure',
      packages: 'Forfaits Madère',
      dailyTours: 'Excursions Journée',
      blog: 'Blog',
      more: 'Plus',
      about: 'À Propos',
      mission: 'Notre Mission',
      contact: 'Contact',
      partners: 'Partenaires (B2B)',
      experiences: 'Expériences',
      services: 'Services'
    },
    header: {
      whatsapp: 'WhatsApp',
      cta: 'Parler à un Expert Madère'
    },
    footer: {
      tagline: 'Vivez Madère autrement — randonnées, levadas et aventures conçues par des passionnés locaux.',
      quickLinks: 'Liens Rapides',
      contact: 'Contact',
      legal: 'Légal',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      cookies: 'Cookies',
      partners: 'Partenaires (B2B)',
      rights: 'Tous droits réservés'
    },
    home: {
      heroTitle1: 'Prêt pour le voyage de',
      heroTitle2: 'votre vie à Madère ?',
      heroSubtitle: 'Découvrez la vraie Madère, loin des foules.',
      ctaSeeTours: 'Voir les Tours Madère',
      ctaCustomize: 'Personnaliser Mon Voyage',
      featuresTitle: 'Experts en Voyages Sur Mesure à Madère',
      featuresLead: 'Vivez Madère à votre rythme avec des circuits expertement conçus et entièrement personnalisables.',
      featuresSub: 'Voyagez à votre façon avec des expériences créées sur mesure par nos guides locaux.',
      featAvoidCrowdsTitle: 'Évitez les Foules',
      featAvoidCrowdsDesc: 'Des itinéraires optimisés vous emmènent loin des sentiers touristiques.',
      featAuthenticTitle: 'Expériences Authentiques',
      featAuthenticDesc: 'Connectez-vous à la culture locale et aux trésors cachés de Madère.',
      featFlexibilityTitle: 'Flexibilité Totale',
      featFlexibilityDesc: 'Adaptez chaque voyage à votre style, budget et envies.',
      experiencesTitle: 'Expériences Authentiques à Madère',
      experiencesSubtitle: 'Voyager avec nous, c’est plus qu’un trip — c’est une expérience.',
      catDailyTitle: 'Excursions Journée',
      catDailySub: 'Découvrez les incontournables de Madère en une journée',
      catDailyDesc: 'Canyoning, Levadas, Tours en Jeep',
      catDiscoveryTitle: 'Voyages Découverte',
      catDiscoverySub: 'Aventures multi-jours à travers les trésors cachés',
      catDiscoveryDesc: 'Funchal, Santana, Porto Moniz, Rabaçal',
      catActiveTitle: 'Voyages Actifs',
      catActiveSub: 'Randonnée, trekking et aventures outdoor',
      catActiveDesc: 'Pico Ruivo, Levadas, Sommets',
      seeAll: 'Voir Toutes Les Expériences',
      seeMore: 'En voir plus',
      from: 'à partir de :',
      durationDay: '1 jour',
      duration35: '3-5 jours',
      duration27: '2-7 jours',
      teamTitle: 'Madeira Outdoors : Passion et Expertise',
      teamLead: 'Nous sommes plus que des experts en voyage — nous sommes des explorateurs passionnés dédiés à créer des aventures inoubliables.',
      teamBody: 'Notre équipe de guides locaux, spécialistes voyage et logisticiens veille à chaque détail. Nous connaissons chaque sentier, chaque belvédère et chaque trésor caché de cette île magnifique.',
      teamCta: 'À Propos de Nous',
      sustainabilityTitle: 'Tourisme Durable : Rendre à Madère',
      sustainabilityLead: 'Nous croyons en un tourisme responsable qui préserve la beauté naturelle de Madère pour les générations futures.',
      sustReforestTitle: 'Reforestation',
      sustReforestDesc: 'Chaque voyage contribue à des actions de plantation pour restaurer la forêt Laurissilva.',
      sustCommunityTitle: 'Soutien aux Communautés',
      sustCommunityDesc: 'Nous travaillons avec les communautés locales pour soutenir l’éducation, les salaires justes et le développement durable.',
      sustResponsibleTitle: 'Tourisme Responsable',
      sustResponsibleDesc: 'Hébergements éco-responsables, réduction des déchets et respect culturel pour un impact positif.',
      sustCta: 'Notre Engagement Durable',
      destinationsTitle: 'Destinations à Découvrir',
      destinationsLead: 'Des forêts luxuriantes aux côtes spectaculaires, Madère est une terre de merveilles infinies.',
      blogTitle: 'Lectures Essentielles pour votre Aventure à Madère',
      blogLead: 'Consultez ces articles pour préparer le voyage de vos rêves à Madère.',
      blogReadMore: 'Lire plus →',
      blogAllCta: 'Tous les Articles',
      contactTitle: 'Commencez à Planifier Votre Voyage !',
      contactLead: 'Dites-nous vos envies — nous les transformons en réalité.',
      formName: 'Nom Complet',
      formEmail: 'Email',
      formPhone: 'Téléphone',
      formMsg: 'Parlez-nous de votre projet de voyage…',
      formBenefit1: 'Aucun paiement requis',
      formBenefit2: 'Réponse en 24h',
      formBenefit3: '100% sur mesure',
      formSubmit: 'Envoyer la demande',
      contactInfoTitle: 'Besoin d’aide ? Contactez-nous directement :',
      faqTitle: 'Questions Fréquentes'
    },
    about: {
      hero: 'À Propos de Nous',
      heroSub: 'Notre histoire, nos racines, et la philosophie qui guide chaque voyage.'
    },
    mission: {
      hero: 'Notre Mission'
    },
    packages: {
      hero: 'Tours Madère et Forfaits Vacances',
      heroSub: 'Choisissez parmi notre sélection d’aventures outdoor conçues pour révéler le meilleur de Madère.',
      filters: { hiking: 'Randonnée', couple: 'Couple', family: 'Famille', cultural: 'Culture' },
      duration: 'Durée',
      group: 'Taille du groupe',
      difficulty: 'Difficulté',
      perPerson: 'par personne',
      from: 'À partir de',
      bookNow: 'Réserver',
      viewDetails: 'Voir Détails',
      readMore: 'En savoir plus',
      highlights: 'Points forts',
      whatsappMsg: 'Bonjour ! Je suis intéressé par le forfait « {title} ». Pouvez-vous m’envoyer plus d’informations ?',
      bookByWhatsapp: 'Réserver via WhatsApp',
      bookByEmail: 'Réserver par Email',
      backToPackages: 'Retour aux forfaits'
    },
    blog: {
      hero: 'Notre Blog',
      heroSub: 'Guides, récits d’aventure et conseils d’initiés pour explorer Madère.',
      readMore: 'Lire l’article',
      back: 'Retour au blog',
      by: 'par',
      published: 'Publié le'
    }
  },
  en: {
    nav: {
      home: 'Home',
      customTrip: 'Customized Trips',
      packages: 'Madeira Trip Packages',
      dailyTours: 'Daily Tours',
      blog: 'Blog',
      more: 'More',
      about: 'About Us',
      mission: 'Our Mission',
      contact: 'Contact',
      partners: 'Partners (B2B)',
      experiences: 'Experiences',
      services: 'Services'
    },
    header: { whatsapp: 'WhatsApp', cta: 'Talk to a Madeira Expert' },
    footer: {
      tagline: 'Live Madeira differently — hikes, levadas and adventures crafted by passionate locals.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      legal: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies',
      partners: 'Partners (B2B)',
      rights: 'All rights reserved'
    },
    home: {
      heroTitle1: 'Ready for the Madeira',
      heroTitle2: 'trip of a lifetime?',
      heroSubtitle: 'Discover authentic Madeira without the crowds.',
      ctaSeeTours: 'See Madeira Tours',
      ctaCustomize: 'Customize My Trip',
      featuresTitle: 'Customized Madeira Tour Experts',
      featuresLead: 'Experience Madeira on your terms with expertly crafted, fully customizable tours.',
      featuresSub: 'Experience Madeira your way with customizable, expertly crafted tours for a unique journey.',
      featAvoidCrowdsTitle: 'Avoid the Crowds',
      featAvoidCrowdsDesc: 'Optimized itineraries let you explore beyond the usual tourist spots.',
      featAuthenticTitle: 'Authentic Experiences',
      featAuthenticDesc: 'Connect with local culture and discover hidden gems of Madeira.',
      featFlexibilityTitle: 'Total Flexibility',
      featFlexibilityDesc: 'Customize your trip to match your style, budget, and preferences.',
      experiencesTitle: 'Authentic Madeira Experiences',
      experiencesSubtitle: "Traveling with us isn't just a trip — it's an experience.",
      catDailyTitle: 'Daily Tours',
      catDailySub: "Explore Madeira's highlights in unforgettable day trips",
      catDailyDesc: 'Canyoning, Levada Walks, Jeep Tours',
      catDiscoveryTitle: 'Discovery Trips',
      catDiscoverySub: 'Multi-day adventures through hidden treasures',
      catDiscoveryDesc: 'Funchal, Santana, Porto Moniz, Rabaçal',
      catActiveTitle: 'Active Trips',
      catActiveSub: 'Hiking, trekking and outdoor adventures',
      catActiveDesc: 'Pico Ruivo, Levadas, Mountain Peaks',
      seeAll: 'See All Experiences',
      seeMore: 'See more',
      from: 'from:',
      durationDay: '1 day',
      duration35: '3-5 days',
      duration27: '2-7 days',
      teamTitle: 'Madeira Outdoors: Passion Meets Expertise',
      teamLead: "We're more than travel experts — we're passionate explorers dedicated to crafting unforgettable journeys.",
      teamBody: 'Our team of local guides, travel specialists and logistics experts ensures every detail of your trip is seamless.',
      teamCta: 'About Us',
      sustainabilityTitle: 'Sustainable Trips: Giving Back to Madeira',
      sustainabilityLead: "We believe in responsible tourism that preserves Madeira's natural beauty for future generations.",
      sustReforestTitle: 'Reforestation',
      sustReforestDesc: 'With every trip, we contribute to tree-planting efforts to restore the Laurissilva forest ecosystem.',
      sustCommunityTitle: 'Community Support',
      sustCommunityDesc: 'We partner with local communities to support education, fair wages and sustainable development.',
      sustResponsibleTitle: 'Responsible Tourism',
      sustResponsibleDesc: 'Eco-friendly accommodations, waste minimization and cultural respect for a positive impact.',
      sustCta: 'Our Commitment to Sustainability',
      destinationsTitle: 'Destinations Waiting for You',
      destinationsLead: 'From lush forests to dramatic coastlines, Madeira is a land of endless wonders.',
      blogTitle: 'Essential Reads for Your Madeira Adventure',
      blogLead: 'Check out these essential articles to plan your dream trip to Madeira.',
      blogReadMore: 'Read more →',
      blogAllCta: 'All Blogs Here!',
      contactTitle: 'Start Planning Your Trip Today!',
      contactLead: "Tell us your travel dreams — we'll make them real.",
      formName: 'Full Name',
      formEmail: 'Email',
      formPhone: 'Phone Number',
      formMsg: 'Tell us more about your travel plans...',
      formBenefit1: 'No payment required',
      formBenefit2: 'Response within 24 hours',
      formBenefit3: '100% tailor-made',
      formSubmit: 'Send Inquiry',
      contactInfoTitle: 'Need help? Contact us directly:',
      faqTitle: 'Frequently Asked Questions'
    },
    about: {
      hero: 'About Us',
      heroSub: 'Our story, our roots, and the philosophy that guides every trip.'
    },
    mission: { hero: 'Our Mission' },
    packages: {
      hero: 'Madeira Tours and Vacation Packages',
      heroSub: 'Choose from our curated selection of outdoor adventures designed to showcase the best of Madeira Island.',
      filters: { hiking: 'Hiking', couple: 'Couple', family: 'Family', cultural: 'Cultural' },
      duration: 'Duration',
      group: 'Group size',
      difficulty: 'Difficulty',
      perPerson: 'per person',
      from: 'From',
      bookNow: 'Book Now',
      viewDetails: 'View Details',
      readMore: 'Read More',
      highlights: 'Highlights',
      whatsappMsg: 'Hi! I am interested in the "{title}" package. Could you send me more information?',
      bookByWhatsapp: 'Book via WhatsApp',
      bookByEmail: 'Book by Email',
      backToPackages: 'Back to packages'
    },
    blog: {
      hero: 'Our Blog',
      heroSub: 'Guides, adventure stories and insider tips for exploring Madeira.',
      readMore: 'Read article',
      back: 'Back to blog',
      by: 'by',
      published: 'Published on'
    }
  },
  pt: {
    nav: {
      home: 'Início',
      customTrip: 'Viagens Personalizadas',
      packages: 'Pacotes da Madeira',
      dailyTours: 'Tours Diários',
      blog: 'Blog',
      more: 'Mais',
      about: 'Sobre Nós',
      mission: 'Missão',
      contact: 'Contacto',
      partners: 'Parceiros (B2B)',
      experiences: 'Experiências',
      services: 'Serviços'
    },
    header: { whatsapp: 'WhatsApp', cta: 'Falar com um Especialista' },
    footer: {
      tagline: 'Viva a Madeira de outra forma — caminhadas, levadas e aventuras criadas por locais apaixonados.',
      quickLinks: 'Links Rápidos',
      contact: 'Contacto',
      legal: 'Legal',
      privacy: 'Privacidade',
      terms: 'Termos',
      cookies: 'Cookies',
      partners: 'Parceiros (B2B)',
      rights: 'Todos os direitos reservados'
    },
    home: {
      heroTitle1: 'Pronto para a viagem',
      heroTitle2: 'da sua vida à Madeira?',
      heroSubtitle: 'Descubra a verdadeira Madeira, sem multidões.',
      ctaSeeTours: 'Ver Tours da Madeira',
      ctaCustomize: 'Personalizar a Minha Viagem',
      featuresTitle: 'Especialistas em Viagens Personalizadas à Madeira',
      featuresLead: 'Viva a Madeira no seu ritmo com tours feitos à medida pelos nossos especialistas locais.',
      featuresSub: 'Viaje à sua maneira com experiências personalizadas para uma jornada única.',
      featAvoidCrowdsTitle: 'Sem Multidões',
      featAvoidCrowdsDesc: 'Itinerários otimizados levam-no para lá dos pontos turísticos tradicionais.',
      featAuthenticTitle: 'Experiências Autênticas',
      featAuthenticDesc: 'Conecte-se à cultura local e descubra os tesouros escondidos da Madeira.',
      featFlexibilityTitle: 'Total Flexibilidade',
      featFlexibilityDesc: 'Adapte cada viagem ao seu estilo, orçamento e preferências.',
      experiencesTitle: 'Experiências Autênticas da Madeira',
      experiencesSubtitle: 'Viajar connosco não é apenas uma viagem — é uma experiência.',
      catDailyTitle: 'Tours Diários',
      catDailySub: 'Descubra a Madeira em passeios de um dia inesquecíveis',
      catDailyDesc: 'Canyoning, Levadas, Tours de Jipe',
      catDiscoveryTitle: 'Viagens de Descoberta',
      catDiscoverySub: 'Aventuras de vários dias pelos tesouros escondidos',
      catDiscoveryDesc: 'Funchal, Santana, Porto Moniz, Rabaçal',
      catActiveTitle: 'Viagens Ativas',
      catActiveSub: 'Caminhadas, trekking e aventuras ao ar livre',
      catActiveDesc: 'Pico Ruivo, Levadas, Picos',
      seeAll: 'Ver Todas as Experiências',
      seeMore: 'Ver mais',
      from: 'a partir de:',
      durationDay: '1 dia',
      duration35: '3-5 dias',
      duration27: '2-7 dias',
      teamTitle: 'Madeira Outdoors: Paixão e Especialização',
      teamLead: 'Mais do que especialistas em viagens — somos exploradores apaixonados a criar aventuras inesquecíveis.',
      teamBody: 'A nossa equipa de guias locais, especialistas de viagens e logística garante que cada detalhe da sua viagem corre na perfeição.',
      teamCta: 'Sobre Nós',
      sustainabilityTitle: 'Turismo Sustentável: Devolver à Madeira',
      sustainabilityLead: 'Acreditamos num turismo responsável que preserva a beleza natural da Madeira para as próximas gerações.',
      sustReforestTitle: 'Reflorestação',
      sustReforestDesc: 'Em cada viagem contribuímos para a plantação de árvores e restauro da Laurissilva.',
      sustCommunityTitle: 'Apoio Comunitário',
      sustCommunityDesc: 'Trabalhamos com comunidades locais para apoiar a educação, salários justos e desenvolvimento sustentável.',
      sustResponsibleTitle: 'Turismo Responsável',
      sustResponsibleDesc: 'Alojamentos ecológicos, redução de resíduos e respeito cultural para um impacto positivo.',
      sustCta: 'O Nosso Compromisso',
      destinationsTitle: 'Destinos à Sua Espera',
      destinationsLead: 'De florestas exuberantes a costas dramáticas, a Madeira é uma terra de maravilhas infinitas.',
      blogTitle: 'Leituras Essenciais para a Sua Aventura na Madeira',
      blogLead: 'Confira estes artigos para preparar a viagem dos seus sonhos.',
      blogReadMore: 'Ler mais →',
      blogAllCta: 'Todos os Artigos',
      contactTitle: 'Comece a Planear a Sua Viagem!',
      contactLead: 'Conte-nos os seus sonhos de viagem — vamos torná-los reais.',
      formName: 'Nome Completo',
      formEmail: 'Email',
      formPhone: 'Telefone',
      formMsg: 'Conte-nos mais sobre os seus planos de viagem...',
      formBenefit1: 'Sem pagamento',
      formBenefit2: 'Resposta em 24h',
      formBenefit3: '100% à medida',
      formSubmit: 'Enviar Pedido',
      contactInfoTitle: 'Precisa de ajuda? Contacte-nos diretamente:',
      faqTitle: 'Perguntas Frequentes'
    },
    about: {
      hero: 'Sobre Nós',
      heroSub: 'A nossa história, raízes e a filosofia que guia cada viagem.'
    },
    mission: { hero: 'A Nossa Missão' },
    packages: {
      hero: 'Tours e Pacotes de Férias na Madeira',
      heroSub: 'Escolha da nossa seleção de aventuras ao ar livre que revelam o melhor da Madeira.',
      filters: { hiking: 'Caminhadas', couple: 'Casal', family: 'Família', cultural: 'Cultura' },
      duration: 'Duração',
      group: 'Tamanho do grupo',
      difficulty: 'Dificuldade',
      perPerson: 'por pessoa',
      from: 'Desde',
      bookNow: 'Reservar',
      viewDetails: 'Ver Detalhes',
      readMore: 'Saber Mais',
      highlights: 'Destaques',
      whatsappMsg: 'Olá! Tenho interesse no pacote "{title}". Podem enviar-me mais informações?',
      bookByWhatsapp: 'Reservar via WhatsApp',
      bookByEmail: 'Reservar por Email',
      backToPackages: 'Voltar aos pacotes'
    },
    blog: {
      hero: 'O Nosso Blog',
      heroSub: 'Guias, histórias de aventura e dicas para explorar a Madeira.',
      readMore: 'Ler artigo',
      back: 'Voltar ao blog',
      by: 'por',
      published: 'Publicado a'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      customTrip: 'Maßgeschneiderte Reisen',
      packages: 'Madeira Reisepakete',
      dailyTours: 'Tagestouren',
      blog: 'Blog',
      more: 'Mehr',
      about: 'Über Uns',
      mission: 'Mission',
      contact: 'Kontakt',
      partners: 'Partner (B2B)',
      experiences: 'Erlebnisse',
      services: 'Dienstleistungen'
    },
    header: { whatsapp: 'WhatsApp', cta: 'Sprich mit einem Madeira-Experten' },
    footer: {
      tagline: 'Erlebe Madeira anders — Wanderungen, Levadas und Abenteuer von leidenschaftlichen Locals.',
      quickLinks: 'Schnelllinks',
      contact: 'Kontakt',
      legal: 'Rechtliches',
      privacy: 'Datenschutz',
      terms: 'AGB',
      cookies: 'Cookies',
      partners: 'Partner (B2B)',
      rights: 'Alle Rechte vorbehalten'
    },
    home: {
      heroTitle1: 'Bereit für die Madeira-',
      heroTitle2: 'Reise deines Lebens?',
      heroSubtitle: 'Entdecke das echte Madeira — fernab vom Massentourismus.',
      ctaSeeTours: 'Madeira Touren',
      ctaCustomize: 'Reise Anpassen',
      featuresTitle: 'Experten für maßgeschneiderte Madeira-Touren',
      featuresLead: 'Erlebe Madeira nach deinem Rhythmus, mit individuell geplanten Touren.',
      featuresSub: 'Reise nach deinem Stil — Touren von lokalen Experten gestaltet.',
      featAvoidCrowdsTitle: 'Keine Massen',
      featAvoidCrowdsDesc: 'Optimierte Routen führen dich abseits der Touristenpfade.',
      featAuthenticTitle: 'Authentische Erlebnisse',
      featAuthenticDesc: 'Verbinde dich mit lokaler Kultur und entdecke versteckte Juwelen.',
      featFlexibilityTitle: 'Volle Flexibilität',
      featFlexibilityDesc: 'Passe deine Reise an deinen Stil, dein Budget und deine Vorlieben an.',
      experiencesTitle: 'Authentische Madeira-Erlebnisse',
      experiencesSubtitle: 'Mit uns reisen ist mehr als ein Trip — es ist ein Erlebnis.',
      catDailyTitle: 'Tagestouren',
      catDailySub: 'Entdecke Madeiras Höhepunkte in unvergesslichen Tagestrips',
      catDailyDesc: 'Canyoning, Levada-Wanderungen, Jeep-Touren',
      catDiscoveryTitle: 'Entdeckungsreisen',
      catDiscoverySub: 'Mehrtägige Abenteuer durch versteckte Schätze',
      catDiscoveryDesc: 'Funchal, Santana, Porto Moniz, Rabaçal',
      catActiveTitle: 'Aktive Reisen',
      catActiveSub: 'Wandern, Trekking und Outdoor-Abenteuer',
      catActiveDesc: 'Pico Ruivo, Levadas, Berggipfel',
      seeAll: 'Alle Erlebnisse Ansehen',
      seeMore: 'Mehr ansehen',
      from: 'ab:',
      durationDay: '1 Tag',
      duration35: '3-5 Tage',
      duration27: '2-7 Tage',
      teamTitle: 'Madeira Outdoors: Leidenschaft trifft Expertise',
      teamLead: 'Wir sind mehr als Reiseexperten — wir sind leidenschaftliche Entdecker.',
      teamBody: 'Unser Team aus lokalen Guides, Reisespezialisten und Logistikexperten sorgt für ein nahtloses Erlebnis.',
      teamCta: 'Über Uns',
      sustainabilityTitle: 'Nachhaltige Reisen: Madeira etwas zurückgeben',
      sustainabilityLead: 'Wir glauben an verantwortungsvollen Tourismus, der Madeiras Natur bewahrt.',
      sustReforestTitle: 'Aufforstung',
      sustReforestDesc: 'Mit jeder Reise pflanzen wir Bäume und unterstützen die Wiederherstellung des Laurissilva-Waldes.',
      sustCommunityTitle: 'Gemeinschaftsunterstützung',
      sustCommunityDesc: 'Wir arbeiten mit lokalen Gemeinden für Bildung, faire Löhne und nachhaltige Entwicklung.',
      sustResponsibleTitle: 'Verantwortungsvoller Tourismus',
      sustResponsibleDesc: 'Umweltfreundliche Unterkünfte, Müllreduzierung und kultureller Respekt.',
      sustCta: 'Unser Nachhaltigkeitsversprechen',
      destinationsTitle: 'Ziele, die auf Dich Warten',
      destinationsLead: 'Von üppigen Wäldern bis zu dramatischen Küsten — Madeira ist ein Land endloser Wunder.',
      blogTitle: 'Essentielle Lektüre für dein Madeira-Abenteuer',
      blogLead: 'Diese Artikel helfen dir bei der Planung deiner Traumreise.',
      blogReadMore: 'Mehr lesen →',
      blogAllCta: 'Alle Artikel',
      contactTitle: 'Plane Deine Reise Noch Heute!',
      contactLead: 'Erzähl uns deine Reiseträume — wir machen sie wahr.',
      formName: 'Vollständiger Name',
      formEmail: 'E-Mail',
      formPhone: 'Telefon',
      formMsg: 'Erzähl uns mehr über deine Reisepläne...',
      formBenefit1: 'Keine Zahlung erforderlich',
      formBenefit2: 'Antwort innerhalb von 24h',
      formBenefit3: '100% maßgeschneidert',
      formSubmit: 'Anfrage Senden',
      contactInfoTitle: 'Brauchst du Hilfe? Kontaktiere uns direkt:',
      faqTitle: 'Häufige Fragen'
    },
    about: {
      hero: 'Über Uns',
      heroSub: 'Unsere Geschichte, unsere Wurzeln und die Philosophie hinter jeder Reise.'
    },
    mission: { hero: 'Unsere Mission' },
    packages: {
      hero: 'Madeira Touren & Reisepakete',
      heroSub: 'Wähle aus unserer kuratierten Auswahl an Outdoor-Abenteuern.',
      filters: { hiking: 'Wandern', couple: 'Paar', family: 'Familie', cultural: 'Kultur' },
      duration: 'Dauer',
      group: 'Gruppengröße',
      difficulty: 'Schwierigkeit',
      perPerson: 'pro Person',
      from: 'Ab',
      bookNow: 'Buchen',
      viewDetails: 'Details Ansehen',
      readMore: 'Mehr Erfahren',
      highlights: 'Highlights',
      whatsappMsg: 'Hallo! Ich interessiere mich für das Paket "{title}". Können Sie mir mehr Informationen senden?',
      bookByWhatsapp: 'Über WhatsApp Buchen',
      bookByEmail: 'Per E-Mail Buchen',
      backToPackages: 'Zurück zu den Paketen'
    },
    blog: {
      hero: 'Unser Blog',
      heroSub: 'Guides, Abenteuergeschichten und Insider-Tipps für Madeira.',
      readMore: 'Artikel lesen',
      back: 'Zurück zum Blog',
      by: 'von',
      published: 'Veröffentlicht am'
    }
  }
};

// Preserve CustomTrip 9-step (ct2) translations
const CT2 = {
  fr: {
    heroTitle: 'Planifiez votre aventure parfaite à Madère',
    heroSubtitle: "Répondez à quelques questions et nos experts locaux concevront un voyage rien que pour vous.",
    progress: 'Étape {step} sur {total}',
    previous: 'Précédent', next: 'suivant', submit: 'Envoyer la demande', sending: 'Envoi…',
    successTitle: 'Merci, {name} !',
    successText: 'Votre demande de voyage a bien été reçue. Une confirmation a été envoyée à {email} — nos experts locaux vous recontactent dans les 24 heures.',
    successCta: "Retour à l'accueil",
    yes: 'OUI', no: 'NON',
    step1Title: 'Où en êtes-vous dans votre projet de voyage ?',
    stageResearch: 'Je me renseigne, je débute mes recherches',
    stagePlanning: 'Je veux commencer à planifier avec un expert local',
    stageBooking: 'Je suis décidé et souhaite réserver très prochainement',
    step2Title: 'Avec qui voyagez-vous ?',
    groupAlone: 'Seul·e', groupCouple: 'En couple', groupFamily: 'En famille', groupGroup: 'En groupe',
    step3InfoTitle: 'Questions supplémentaires',
    step3InfoText: 'Nous allons vous poser quelques questions afin de vous proposer le voyage qui correspond le mieux à vos envies.',
    step3Title: 'Combien de personnes participent à ce voyage ?',
    adults: 'Adultes', children: 'Enfants', childrenHint: '(moins de 18 ans)',
    step4InfoTitle: 'Parlez-nous de votre projet',
    step4InfoText: 'Ces informations nous permettent de mieux répondre à votre demande et de vous proposer un projet adapté à vos envies.',
    step4Title: 'Connaissez-vous vos dates de voyage ?',
    step5InfoTitle: 'Parlez-nous de votre projet',
    step5InfoText: 'Avoir une idée de votre période de départ nous permettra de mieux ajuster notre proposition.',
    step5Title: 'Quand souhaitez-vous partir ?',
    step5DatePlaceholder: 'Date approximative du voyage',
    monthsSingleHint: 'Sélectionnez le mois de départ',
    monthsMultiHint: 'Sélectionnez les mois qui vous intéressent (un ou plusieurs)',
    monthsHeading: 'Quels mois vous intéressent ?',
    step5DurationLabel: 'Combien de temps ?',
    duration8: '8 jours', duration15: '15 jours', durationLessThan5: 'Moins de 5 jours', duration5: '5 jours', durationMore: 'Plus',
    durationOtherPlaceholder: 'Précisez la durée',
    step6ActivitiesTitle: 'Quelles activités vous intéressent le plus à Madère ?',
    step6ActivitiesHint: 'Sélectionnez autant que vous voulez',
    activities: {
      hiking: 'Randonnée', canyoning: 'Canyoning', diving: 'Plongée / Snorkeling',
      whales: 'Observation baleines & dauphins', jeep: 'Excursions 4x4 Jeep',
      paragliding: 'Parapente', fishing: 'Pêche en bateau (big game)', biking: 'VTT (Bike tours)',
      swimming: 'Nage en eau libre', horse: 'Équitation en forêt', buggy: 'Buggy safari',
      desertas: 'Excursion îles Desertas', surf: 'Cours de surf', sightseeing: 'Levers / couchers de soleil',
      cultural: 'Excursions culturelles', gastronomy: 'Expérience gastronomique'
    },
    step6InfoTitle: 'Parlez-nous de votre projet !',
    step6InfoText: 'Connaître votre budget nous aide à personnaliser nos recommandations.',
    step6Title: 'Avez-vous déjà une idée de budget pour votre voyage ?',
    step7InfoText: "Indiquez votre budget par personne, hors vols internationaux.",
    step7Title: 'Quel est votre budget par personne ?',
    step7Or: 'Ou', step7CustomPlaceholder: '€2000',
    step8InfoTitle: 'Parlez-nous de votre projet',
    step8InfoText: 'Ces informations nous permettront de vous proposer un projet au plus proche de vos envies.',
    step8Title: 'Parlez-nous de votre projet !',
    step8Placeholder: "Dites-nous ce que vous voulez pour ce voyage : les étapes incontournables, les activités, vos centres d'intérêt ou au contraire ce que vous ne voulez pas faire…",
    step8CharsCounter: '{count}/1000 ({min} caractères minimum)',
    step9InfoTitle: "Dernière étape avant l'envoi de votre demande !",
    step9InfoText: "Pour confirmer votre demande, laissez-nous vos coordonnées.",
    step9Title: 'Restons en contact',
    firstName: 'Prénom', lastName: 'Nom', email: 'Email', phone: 'Téléphone', country: 'Pays de résidence'
  },
  en: {
    heroTitle: 'Plan your perfect Madeira adventure',
    heroSubtitle: 'Answer a few short questions and our local experts will design a trip just for you.',
    progress: 'Step {step} of {total}',
    previous: 'Previous', next: 'following', submit: 'Submit request', sending: 'Sending…',
    successTitle: 'Thank you, {name}!',
    successText: 'Your trip request has been received. A confirmation was sent to {email} — our local experts will reach out within 24 hours.',
    successCta: 'Back to home',
    yes: 'YES', no: 'NO',
    step1Title: 'Where are you in your travel project?',
    stageResearch: "I'm inquiring, I'm at the beginning of my research",
    stagePlanning: 'I want to start planning with a local expert',
    stageBooking: 'I have decided and I want to book very soon',
    step2Title: 'Who are you traveling with?',
    groupAlone: 'Alone', groupCouple: 'As a couple', groupFamily: 'With your family', groupGroup: 'In group',
    step3InfoTitle: 'Additional questions',
    step3InfoText: 'We will ask you some additional questions in order to offer you the trip that best suits your desires.',
    step3Title: 'How many people are participating in this trip?',
    adults: 'Adults', children: 'Children', childrenHint: '(under 18 years old)',
    step4InfoTitle: 'Tell us about your project',
    step4InfoText: 'This information will make it possible to better respond to your request and to offer you a travel project adapted to your desires.',
    step4Title: 'Do you know your travel dates?',
    step5InfoTitle: 'Tell us about your project',
    step5InfoText: 'Having an idea of your departure period will allow us to best adjust our travel proposal.',
    step5Title: 'When do you want to leave?',
    step5DatePlaceholder: 'Approximate date of travel',
    monthsSingleHint: 'Pick your departure month',
    monthsMultiHint: 'Pick the months you are interested in (one or several)',
    monthsHeading: 'Which months work for you?',
    step5DurationLabel: 'How long?',
    duration8: '8 days', duration15: '15 days', durationLessThan5: 'Less than 5 days', duration5: '5 days', durationMore: 'More',
    durationOtherPlaceholder: 'Specify the duration',
    step6ActivitiesTitle: 'Which activities interest you the most?',
    step6ActivitiesHint: 'Choose as many as you like',
    activities: {
      hiking: 'Hiking', canyoning: 'Canyoning', diving: 'Diving / Snorkeling',
      whales: 'Whales & Dolphins watching', jeep: '4x4 Jeep excursions',
      paragliding: 'Paragliding', fishing: 'Boat fishing (big game fishing)', biking: 'Bike tours (MTB)',
      swimming: 'Open Water Swimming tour', horse: 'Horse riding (in the forest)', buggy: 'Buggy safari',
      desertas: 'Boat trip to Desertas Islands', surf: 'Surf lessons',
      sightseeing: 'Sightseeing trips (sunrises/sunsets)', cultural: 'Cultural excursions', gastronomy: 'Gastronomical experience'
    },
    step6InfoTitle: 'Tell us about your project!',
    step6InfoText: 'Knowing your budget helps us personalize our recommendations.',
    step6Title: 'Do you already have a budget idea for your trip?',
    step7InfoText: 'Please tell us your budget per person, excluding international flights.',
    step7Title: 'What is your budget per person?',
    step7Or: 'Or', step7CustomPlaceholder: '€2000',
    step8InfoTitle: 'Tell us about your project',
    step8InfoText: 'This information will allow us to offer you a project as close as possible to your desires.',
    step8Title: 'Tell us about your project!',
    step8Placeholder: "Tell us what you want for this trip…",
    step8CharsCounter: '{count}/1000 ({min} characters minimum)',
    step9InfoTitle: 'Last step before sending your request!',
    step9InfoText: 'To confirm your request, leave us your contact details.',
    step9Title: "Let's get in touch",
    firstName: 'First name', lastName: 'Last name', email: 'Email', phone: 'Phone', country: 'Country of residence'
  },
  pt: {
    heroTitle: 'Planeie a sua aventura perfeita na Madeira',
    heroSubtitle: 'Responda a algumas perguntas e os nossos especialistas locais vão desenhar uma viagem só para si.',
    progress: 'Passo {step} de {total}',
    previous: 'Anterior', next: 'seguinte', submit: 'Enviar pedido', sending: 'A enviar…',
    successTitle: 'Obrigado, {name}!',
    successText: 'O seu pedido foi recebido. Uma confirmação foi enviada para {email} — os nossos especialistas locais entrarão em contacto em 24 horas.',
    successCta: 'Voltar ao início',
    yes: 'SIM', no: 'NÃO',
    step1Title: 'Em que fase do seu projeto de viagem se encontra?',
    stageResearch: 'Estou a informar-me, no início da minha pesquisa',
    stagePlanning: 'Quero começar a planear com um especialista local',
    stageBooking: 'Estou decidido e quero reservar muito em breve',
    step2Title: 'Com quem viaja?',
    groupAlone: 'Sozinho(a)', groupCouple: 'Em casal', groupFamily: 'Em família', groupGroup: 'Em grupo',
    step3InfoTitle: 'Perguntas adicionais',
    step3InfoText: 'Vamos fazer-lhe algumas perguntas para podermos propor a viagem que melhor se adapta aos seus desejos.',
    step3Title: 'Quantas pessoas vão participar nesta viagem?',
    adults: 'Adultos', children: 'Crianças', childrenHint: '(menores de 18 anos)',
    step4InfoTitle: 'Fale-nos do seu projeto',
    step4InfoText: 'Estas informações permitir-nos-ão responder melhor ao seu pedido e propor um projeto adaptado aos seus desejos.',
    step4Title: 'Já sabe as datas da sua viagem?',
    step5InfoTitle: 'Fale-nos do seu projeto',
    step5InfoText: 'Ter uma ideia da sua data de partida vai permitir-nos ajustar a proposta.',
    step5Title: 'Quando deseja partir?',
    step5DatePlaceholder: 'Data aproximada da viagem',
    monthsSingleHint: 'Escolha o mês de partida',
    monthsMultiHint: 'Escolha os meses do seu interesse (um ou vários)',
    monthsHeading: 'Que meses lhe interessam?',
    step5DurationLabel: 'Por quanto tempo?',
    duration8: '8 dias', duration15: '15 dias', durationLessThan5: 'Menos de 5 dias', duration5: '5 dias', durationMore: 'Mais',
    durationOtherPlaceholder: 'Especifique a duração',
    step6ActivitiesTitle: 'Quais destas atividades mais lhe interessam ao viajar para a Madeira?',
    step6ActivitiesHint: 'Escolha as que quiser',
    activities: {
      hiking: 'Caminhadas', canyoning: 'Canyoning', diving: 'Mergulho / Snorkeling',
      whales: 'Observação de baleias e golfinhos', jeep: 'Passeios 4x4 Jeep',
      paragliding: 'Parapente', fishing: 'Pesca de alto mar', biking: 'BTT (Bike tours)',
      swimming: 'Natação em águas abertas', horse: 'Passeios a cavalo na floresta', buggy: 'Buggy safari',
      desertas: 'Passeio de barco às Desertas', surf: 'Aulas de surf',
      sightseeing: 'Nascer / pôr-do-sol', cultural: 'Excursões culturais', gastronomy: 'Experiência gastronómica'
    },
    step6InfoTitle: 'Fale-nos do seu projeto!',
    step6InfoText: 'Saber o seu orçamento ajuda-nos a personalizar as recomendações.',
    step6Title: 'Já tem uma ideia de orçamento para a sua viagem?',
    step7InfoText: 'Por favor indique o seu orçamento por pessoa, excluindo voos internacionais.',
    step7Title: 'Qual é o seu orçamento por pessoa?',
    step7Or: 'Ou', step7CustomPlaceholder: '€2000',
    step8InfoTitle: 'Fale-nos do seu projeto',
    step8InfoText: 'Estas informações vão permitir-nos propor um projeto o mais próximo possível dos seus desejos.',
    step8Title: 'Fale-nos do seu projeto!',
    step8Placeholder: 'Diga-nos o que quer para esta viagem…',
    step8CharsCounter: '{count}/1000 (mínimo {min} caracteres)',
    step9InfoTitle: 'Último passo antes de enviar o seu pedido!',
    step9InfoText: 'Para confirmar o seu pedido, deixe-nos os seus contactos.',
    step9Title: 'Vamos falar',
    firstName: 'Primeiro nome', lastName: 'Apelido', email: 'Email', phone: 'Telefone', country: 'País de residência'
  },
  de: {
    heroTitle: 'Plane Dein perfektes Madeira-Abenteuer',
    heroSubtitle: 'Beantworte ein paar kurze Fragen und unsere lokalen Experten gestalten eine Reise nur für Dich.',
    progress: 'Schritt {step} von {total}',
    previous: 'Zurück', next: 'weiter', submit: 'Anfrage senden', sending: 'Wird gesendet…',
    successTitle: 'Vielen Dank, {name}!',
    successText: 'Deine Reiseanfrage ist eingegangen. Eine Bestätigung wurde an {email} gesendet — unsere lokalen Experten melden sich innerhalb von 24 Stunden.',
    successCta: 'Zurück zur Startseite',
    yes: 'JA', no: 'NEIN',
    step1Title: 'Wo stehst Du in Deiner Reiseplanung?',
    stageResearch: 'Ich informiere mich, ich bin noch am Anfang der Recherche',
    stagePlanning: 'Ich möchte mit einem lokalen Experten planen',
    stageBooking: 'Ich bin entschieden und möchte bald buchen',
    step2Title: 'Mit wem reist Du?',
    groupAlone: 'Allein', groupCouple: 'Als Paar', groupFamily: 'Mit der Familie', groupGroup: 'In einer Gruppe',
    step3InfoTitle: 'Zusätzliche Fragen',
    step3InfoText: 'Wir stellen Dir noch ein paar Fragen, damit wir Dir die Reise vorschlagen können, die am besten zu Deinen Wünschen passt.',
    step3Title: 'Wie viele Personen nehmen an dieser Reise teil?',
    adults: 'Erwachsene', children: 'Kinder', childrenHint: '(unter 18 Jahre)',
    step4InfoTitle: 'Erzähl uns von Deinem Projekt',
    step4InfoText: 'Diese Informationen helfen uns, besser auf Deine Anfrage einzugehen.',
    step4Title: 'Kennst Du Deine Reisedaten?',
    step5InfoTitle: 'Erzähl uns von Deinem Projekt',
    step5InfoText: 'Eine grobe Vorstellung Deines Reisezeitraums hilft uns, das Angebot anzupassen.',
    step5Title: 'Wann möchtest Du verreisen?',
    step5DatePlaceholder: 'Ungefähres Reisedatum',
    monthsSingleHint: 'Wähle Deinen Reisemonat',
    monthsMultiHint: 'Wähle die Monate, die Dich interessieren',
    monthsHeading: 'Welche Monate passen Dir?',
    step5DurationLabel: 'Wie lange?',
    duration8: '8 Tage', duration15: '15 Tage', durationLessThan5: 'Weniger als 5 Tage', duration5: '5 Tage', durationMore: 'Mehr',
    durationOtherPlaceholder: 'Dauer angeben',
    step6ActivitiesTitle: 'Welche dieser Aktivitäten interessieren Dich am meisten?',
    step6ActivitiesHint: 'Wähle so viele Du möchtest',
    activities: {
      hiking: 'Wandern', canyoning: 'Canyoning', diving: 'Tauchen / Schnorcheln',
      whales: 'Wale & Delfine beobachten', jeep: '4x4 Jeep-Touren',
      paragliding: 'Paragliding', fishing: 'Hochseefischen', biking: 'Mountainbike-Touren',
      swimming: 'Freiwasserschwimmen', horse: 'Reiten im Wald', buggy: 'Buggy-Safari',
      desertas: 'Bootsfahrt zu den Desertas-Inseln', surf: 'Surfunterricht',
      sightseeing: 'Sonnenauf-/Untergänge', cultural: 'Kulturelle Ausflüge', gastronomy: 'Kulinarisches Erlebnis'
    },
    step6InfoTitle: 'Erzähl uns von Deinem Projekt!',
    step6InfoText: 'Dein Budget zu kennen hilft uns, unsere Empfehlungen zu personalisieren.',
    step6Title: 'Hast Du bereits eine Budgetvorstellung für Deine Reise?',
    step7InfoText: 'Bitte gib Dein Budget pro Person an, ohne internationale Flüge.',
    step7Title: 'Wie hoch ist Dein Budget pro Person?',
    step7Or: 'Oder', step7CustomPlaceholder: '€2000',
    step8InfoTitle: 'Erzähl uns von Deinem Projekt',
    step8InfoText: 'Diese Informationen ermöglichen uns ein Angebot, das Deinen Wünschen so nahe wie möglich kommt.',
    step8Title: 'Erzähl uns von Deinem Projekt!',
    step8Placeholder: 'Sag uns, was Du Dir für diese Reise wünschst…',
    step8CharsCounter: '{count}/1000 (mindestens {min} Zeichen)',
    step9InfoTitle: 'Letzter Schritt vor dem Absenden Deiner Anfrage!',
    step9InfoText: 'Um Deine Anfrage zu bestätigen, hinterlasse uns bitte Deine Kontaktdaten.',
    step9Title: 'Lass uns in Kontakt treten',
    firstName: 'Vorname', lastName: 'Nachname', email: 'E-Mail', phone: 'Telefon', country: 'Land'
  }
};

export const translations = {
  fr: { ...COMMON.fr, ct2: CT2.fr },
  en: { ...COMMON.en, ct2: CT2.en },
  pt: { ...COMMON.pt, ct2: CT2.pt },
  de: { ...COMMON.de, ct2: CT2.de }
};
